import { useGetSignUpVerifyParams } from "./_hooks/use-verify-sign-up";

export const AuthVerifyPage = () => {
	useGetSignUpVerifyParams();

	return <></>;
};
